// extracted by mini-css-extract-plugin
module.exports = {"label":"membership-level-label_label__b_wh4","label__badge":"membership-level-label_label__badge__9qGCj"};